import styled from 'styled-components';
import { Z_INDEX } from '~/src/styles/tokens/z-index';
import { rem } from '~/src/helpers/rem-converter.helper';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { COLORS } from '~/src/styles/tokens/colors';
import { shadows } from '~/src/styles/variables';
import { ScrollbarStyles } from '~/src/styles/shared-css/custom-scroll';

export const ListWindowWrap = styled.div`
    position: absolute;
    z-index: ${Z_INDEX.level2};
    width: 100%;
`;

export const ListWindow = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100%;
    max-height: 50vh;
    overflow-y: auto;
    padding: ${rem(6)} 0;
    border-radius: ${BORDER_RADIUS.medium6};
    box-shadow: ${shadows.geolocation};
    background-color: ${COLORS.backgroundPrimary};
    ${ScrollbarStyles};
`;

export const ListItem = styled.div<{ isClickable: boolean; }>`
    padding: ${rem(10)} ${rem(12)};
    cursor: ${p => p.isClickable ? 'pointer' : 'auto'};

    &:hover {
        background-color: ${p => p.isClickable ? `${COLORS.backgroundHover}` : 'initial'};
    }
`;
